import React from "react";

import { DynamicForm } from "src/components/Form";

const fields = options => ({ t }) => [
  {
    key: "name",
    label: "Your name",
    required: true,
  },
  {
    key: "phoneNumber",
    label: t("forms.phoneNumber"),
    required: true,
  },
  {
    key: "email",
    label: t("forms.emailAddress"),
    inputProps: {
      type: "email",
    },
    required: true,
    constraints: {
      equality: {
        attribute: "phoneNumber",
        message: `^${t("forms.phoneOrEmailError")}`,
        comparator: (v1, v2) => v1 || v2,
      },
      email: true,
    },
  },
  {
    key: "isMember",
    label: "Are you a Ball State Financial or Financial Center member?",
    type: "optionButtons",
    inputProps: {
      options: [
        {
          value: "Yes",
          label: t("forms.feedback.yes"),
        },
        {
          value: "No",
          label: t("forms.feedback.no"),
        },
      ],
    },
  },
];

const BallStateForm = ({ moduleKey, options }) => (
  <DynamicForm
    formKey={moduleKey}
    fields={fields(options.options)}
    defaultSuccessMessageKey="forms.ballStateSuccessMessage"
  />
);

export default BallStateForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/BallStateForm.js